<template lang="html">
  <div class="wcc fields">
    <Field label="Rate" :boundData="commissionData.value.rate"></Field>
    <Field label="Bonus" v-if="commissionData.value.bonus" :boundData="commissionData.value.bonus"></Field>
  </div>
</template>
<script>
  import Field from './Field.vue'
  export default {
    props: ['commissionData'],
    components: {
      Field
    }
  }
</script>
<style lang="scss">
</style>